// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__EoBuc","logo":"styles_logo__5-Rdn","content":"styles_content__jPuZ2","code":"styles_code__m2zwL"};